export enum PostMessage {
    CloseModal = 'inconvo:closeModal',
}
